import Image from "next/future/image";

import { Col, Container, Row } from "react-bootstrap";
import SectionHead from "../Shared/SectionHead";
import { useIntl } from "react-intl";
import CircleIcon from "../../assets/images/svg/feature-circle2.svg";
const Features = ({ featuresData }) => {
  const { formatMessage, locale } = useIntl();
  return (
    <section className="features-section py-5">
      <Container>
        <SectionHead title={formatMessage({ id: "Why Us" })} />
        <Row className="gy-4 justify-content-center">
          {featuresData?.map((item, index) => {
            return (
              <Col
                lg={3}
                md={6}
                sm={6}
                xs={12}
                key={index}
                className="feature-col"
              >
                <div
                  className="feature-item"
                  data-aos="fade-up"
                  data-aos-duration={(index + 1) * 100}
                  data-aos-delay={(index + 1) * 100}
                >
                  <div className="layout-sec">
                    <div className="circle">
                      <Image
                        src={CircleIcon}
                        alt="circle image"
                        loading="lazy"
                      />
                      <div className="icon-sec">
                        <Image
                          src={`${process.env.NEXT_PUBLIC_MAIN_URL}/${item?.icon}`}
                          alt=""
                          width={50}
                          height={50}
                          loading="lazy"
                        />
                      </div>
                    </div>
                  </div>
                  <h4>{item?.name?.[locale]}</h4>
                  <p>{item?.description}</p>
                </div>
              </Col>
            );
          })}
        </Row>
      </Container>
    </section>
  );
};

export default Features;
